import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ $withStyle }) =>
    $withStyle &&
    css`
      background-color: #faefde;
      box-shadow: inset 0 5px 6px 2px #f1e2cf;
      border-radius: 0.5rem;
      flex: 1;
    `}
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding: 1rem 0.1rem;
`;

export const Coins = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  justify-content: center;
`;

export const Good = styled.div`
  position: relative;
  color: #ffffff;
  text-shadow:
    -1px -1px 0 black,
    1px -1px 0 black,
    -1px 1px 0 black,
    1px 1px 0 black;
  font-size: 1.1em;
  font-weight: 700;
  text-align: center;
`;

export const Asset = styled.img.attrs(({ src }) => ({
  src,
}))``;

export const CoinsValue = styled.div`
  font-size: ${({ $length }) => ($length > 4 ? '1.8em' : '2em')};
  font-weight: 700;
`;

export const Quantity = styled.div`
  position: absolute;
  left: ${({ $isVoucher }) => ($isVoucher ? '46px' : '40px')};
  right: 0;
  bottom: 0;
`;

export const Voucher = styled.div`
  position: absolute;
  top: 6px;
  left: 0;
  right: 0;
`;
